import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ea-toggle',
    templateUrl: './ea-toggle.component.html',
    styleUrls: ['./ea-toggle.component.scss'],
    standalone: false
})
export class EaToggleComponent implements OnInit {
  @Input() on: boolean = true;
  @Input() name: string = 'pinel';
  @Output() prToggle = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onToggle(event: any) {
    this.on = !this.on;
    this.prToggle.emit({ on: this.on });
  }
}
